import { render, staticRenderFns } from "./EstimationDocuments.vue?vue&type=template&id=4e7edfc6"
import script from "./EstimationDocuments.vue?vue&type=script&lang=js"
export * from "./EstimationDocuments.vue?vue&type=script&lang=js"
import style0 from "./EstimationDocuments.vue?vue&type=style&index=0&id=4e7edfc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports